
import store from '../../config/store'
import i18n from '../../locales'

export default {
  
  props: {
    model: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    store,
    format: 'xlsx',
    includeAttach: true,
    selectedExportType: 'current_page',
    exportType: {
      current_page: i18n.t('sidepanel.operation_export.to_export.current_page')
    },
    maxOperations: 30
  }),

  computed: {
    hasFilters () {
      return Object.keys(this.model).length
    },
    
    filtersSelected () {
      return this.selectedExportType === 'use_filters'
    }
  },

  mounted () {
    if (this.hasFilters) {
      this.exportType.use_filters = this.$i18n.t('sidepanel.operation_export.to_export.use_filters')
      this.selectedExportType = 'use_filters'
    }
  },

  methods: {
    onSubmit () {
      let params = {
        format: this.format,
        include_attach: this.includeAttach
      }
      if (this.model.from && this.filtersSelected) {
        params.from = this.model.from
      }
      if (this.model.to && this.filtersSelected) {
        params.to = this.model.to
      }
      this.downloadFileFromUrl('/operations/export', params).then(() => {
        this.hideSidePanel()
      })
    }
  }
}
